// Núcleo do chat da LIA de BI. Usado pela tela cloud-bi/lia (resources/js/pages/lia.js) e pelo modal de
// tela cheia do header 2027 (resources/2027/js/components/LiaFs.js). Fica FORA de resources/2027: desligar o
// shell 2027 não pode derrubar a tela cloud-bi/lia (spec, critério 38).
//
// Regras deste módulo (docs/lia-header-modal):
// - nada é delegado no document; quem usa liga os handlers no próprio elemento (duas instâncias na mesma página);
// - todo id criado leva o prefixo da instância (F-2);
// - HTML de resposta/salvo passa por prepararCorpo() antes de entrar no DOM (ui-v02/v03, "Forma do Salvo");
// - texto vindo da IA ou do usuário entra por textContent; HTML só o corpo saneado.
'use strict';

const $ = window.jQuery;

// ── Textos ────────────────────────────────────────────────────────────────────────────────────────
// O mapa vem pronto do Blade (cloud-bi/lia-i18n.blade.php), já com fallback pt-BR. Aqui não há texto
// solto: id ausente aparece como o próprio id (visível), nunca em branco.
const lerTextos = function (el) {
    if (!el) return null;
    try {
        const m = JSON.parse(el.getAttribute('data-lia-i18n') || '');
        return (m && typeof m === 'object' && !Array.isArray(m)) ? m : null;
    } catch (e) {
        return null;
    }
};

const tradutor = function (mapa) {
    return function (id, vars) {
        let s = mapa[id];
        if (typeof s !== 'string' || s.trim() === '') {
            console.error('[LIA] texto ausente no data-lia-i18n: ' + id);
            s = id;
        }
        if (vars) {
            Object.keys(vars).forEach(function (k) { s = s.split('{' + k + '}').join(String(vars[k])); });
        }
        return s;
    };
};

// ── Escape ────────────────────────────────────────────────────────────────────────────────────────
// 5 caracteres (ui-v03: o h5 do Salvo v2 usa escapeHtml de &, <, >, " e ').
const escapeHtml = function (str) {
    return String(str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
};
// Atributo: o mesmo escapeAttr da tela original (lia.js), usado no data-lia-rules.
const escapeAttr = function (str) {
    return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
};

// ── DOM ───────────────────────────────────────────────────────────────────────────────────────────
const el = function (tag, cls, texto) {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (texto !== undefined && texto !== null) n.textContent = texto;
    return n;
};
const icone = function (nome, cls) {
    const i = el('i', 'ai ai-' + nome + (cls ? ' ' + cls : ''));
    i.setAttribute('aria-hidden', 'true');
    return i;
};
const botao = function (cls, texto) {
    const b = el('button', cls, texto);
    b.type = 'button';
    return b;
};

// ── Datas ─────────────────────────────────────────────────────────────────────────────────────────
// fav.created é 'YYYY-MM-DD HH:MM:SS' (one/order, coluna sem cast). new Date() dá Invalid Date no Safari.
const dataSalvo = function (created) {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(created || ''));
    return m ? (m[3] + '/' + m[2] + '/' + m[1]) : '';
};

// ── Transporte ────────────────────────────────────────────────────────────────────────────────────
// Falha de rede/5xx = 'conn'. 419 (CSRF velho depois de logout) ou corpo não-JSON (redirect para o
// login seguido pelo XHR) = 'session' (ui-v02, decisão 1).
const tipoFalha = function (xhr, textStatus) {
    if (xhr && xhr.status === 419) return 'session';
    if (textStatus === 'parsererror') return 'session';
    return 'conn';
};

const token = function () {
    return (typeof window.CSRF_TOKEN !== 'undefined') ? window.CSRF_TOKEN : $('meta[name="csrf-token"]').attr('content');
};

const pedir = function (opts) {
    const d = $.Deferred();
    $.ajax(Object.assign({ dataType: 'json' }, opts))
        .done(function (res) { d.resolve(res); })
        .fail(function (xhr, textStatus) { d.reject(tipoFalha(xhr, textStatus)); });
    return d.promise();
};

const opcoesCategoria = function (selection) {
    const lista = (selection && Array.isArray(selection.options)) ? selection.options : [];
    const out = [];
    lista.forEach(function (o) {
        if (!o || typeof o !== 'object') return;
        const id = String(o.id !== undefined && o.id !== null ? o.id : (o.id_categoria_pai !== undefined && o.id_categoria_pai !== null ? o.id_categoria_pai : '')).trim();
        const label = String(o.label !== undefined && o.label !== null ? o.label : (o.categoria_pai !== undefined && o.categoria_pai !== null ? o.categoria_pai : '')).trim();
        if (id && label) out.push({ id: id, label: label });
    });
    return out;
};

// Resultado do lia-chat em um dos casos da ui-v02 (A3/A4/A5).
const resultadoChat = function (res, pergunta) {
    if (!res || typeof res !== 'object') return { tipo: 'notBuilt' };
    if (res.error) return { tipo: 'server', message: (typeof res.message === 'string' && res.message.trim()) ? res.message : '' };
    const r = res.result;
    if (!r || typeof r !== 'object') return { tipo: 'notBuilt' };
    if (r.needsSelection) {
        const ops = opcoesCategoria(r.selection);
        if (!ops.length) return { tipo: 'notBuilt' };
        const orig = (r.selection && typeof r.selection.original_message === 'string' && r.selection.original_message.trim())
            ? r.selection.original_message : pergunta;
        return { tipo: 'selection', options: ops, original: orig };
    }
    if (typeof r.html !== 'string' || r.html.trim() === '') return { tipo: 'notBuilt' };
    return { tipo: 'ok', result: r };
};

// Sem as 4 URLs o cliente não existe: $.ajax com url vazia faria POST na própria página (escrita sem alvo).
const cliente = function (urls) {
    ['chat', 'favoriteStore', 'favorites', 'favoriteBase'].forEach(function (k) {
        if (!urls || typeof urls[k] !== 'string' || urls[k].trim() === '') throw new Error('[LIA] URL ausente: ' + k);
    });
    return {
        // dados: { message, store_id?, selected_category_id?, selected_category_name? }
        chat: function (dados) {
            const d = $.Deferred();
            pedir({ url: urls.chat, method: 'POST', data: Object.assign({ _token: token() }, dados) })
                .done(function (res) { d.resolve(resultadoChat(res, dados.message)); })
                .fail(function (tipo) { d.resolve({ tipo: tipo }); });
            return d.promise();
        },
        // { tipo: 'ok', itens } | { tipo: 'server'|'conn'|'session' }
        listar: function () {
            const d = $.Deferred();
            pedir({ url: urls.favorites, method: 'GET', cache: false })
                .done(function (res) {
                    if (res && res.error === false && Array.isArray(res.result)) d.resolve({ tipo: 'ok', itens: res.result });
                    else d.resolve({ tipo: 'server' });
                })
                .fail(function (tipo) { d.resolve({ tipo: tipo }); });
            return d.promise();
        },
        salvar: function (titulo, result) {
            const d = $.Deferred();
            pedir({
                url: urls.favoriteStore, method: 'POST',
                data: { title: titulo, html: htmlSalvoV2(titulo, result), charts: JSON.stringify(result.charts || []), _token: token() }
            })
                .done(function (res) {
                    if (res && typeof res === 'object' && res.error === false) d.resolve({ tipo: 'ok' });
                    else d.resolve({ tipo: 'server', message: (res && typeof res.message === 'string') ? res.message : '' });
                })
                .fail(function (tipo) { d.resolve({ tipo: tipo }); });
            return d.promise();
        },
        // Remove SÓ o id clicado (regra 6 da persona).
        remover: function (id) {
            const d = $.Deferred();
            pedir({ url: urls.favoriteBase + '/' + encodeURIComponent(id), method: 'POST', data: { _method: 'DELETE', _token: token() } })
                .done(function (res) {
                    if (res && typeof res === 'object' && res.error === false) d.resolve({ tipo: 'ok' });
                    else d.resolve({ tipo: 'server', message: (res && typeof res.message === 'string') ? res.message : '' });
                })
                .fail(function (tipo) { d.resolve({ tipo: tipo }); });
            return d.promise();
        }
    };
};

// ── Salvo "geração 2" (ui-v03) ─────────────────────────────────────────────────────────────────────
// Concatenação, nunca DOM serializado (F-8): o result.html vai exatamente como chegou do lia-chat.
const htmlSalvoV2 = function (titulo, result) {
    return '<div class="lia-saved" data-lia-saved="2" data-lia-rules="' + escapeAttr(JSON.stringify(result.rules || [])) + '">' +
        '<h5 class="lia-result-title"><span><i class="fas fa-comment-dots mr-2 text-primary"></i>' + escapeHtml(titulo) + '</span></h5>' +
        (result.html || '') +
        '</div>';
};

// ── prepararCorpo (ui-v02 passos 1, 6, 7, 8; ui-v03 passos 2, 2b, 3, 4, 5) ─────────────────────────
const REMOVER_TODOS = '.lia-result-title, script, style, link, base, meta, iframe, object, embed, form, button, input, select, textarea';
// SMIL reescreve atributo DEPOIS do passo 6 (<animate attributeName="href" values="javascript:…">,
// <set … to="javascript:…">) — LICOES lia-header-modal 12. Comparado por localName para não depender
// da caixa do seletor: nome SVG é camelCase e um seletor em minúsculas ('animatemotion') não casa o
// elemento em nenhum dos dois caminhos (template e document); localName minusculizado casa sempre.
const SMIL = ['animate', 'set', 'animatemotion', 'animatetransform', 'animatecolor'];
const removerSmil = function (raiz) {
    raiz.querySelectorAll('*').forEach(function (n) {
        if (SMIL.indexOf(String(n.localName).toLowerCase()) !== -1) remover(n);
    });
};
const ATRIBUTOS_URL = ['href', 'src', 'xlink:href', 'action', 'formaction', 'poster', 'background'];

const remover = function (n) { if (n && n.parentNode) n.parentNode.removeChild(n); };

const regrasDoV1 = function (frag) {
    const regras = [];
    frag.querySelectorAll('.lia-rules-panel tbody tr').forEach(function (tr) {
        const tds = Array.prototype.filter.call(tr.children, function (c) { return c.tagName === 'TD'; });
        if (tds.length < 2) return;
        const r = { regra: tds[0].textContent.trim(), valor: tds[1].textContent };
        if (tds[1].querySelector('code')) r.code = true;
        regras.push(r);
    });
    return regras;
};

const limparV1 = function (frag) {
    frag.querySelectorAll('.lia-save-btn').forEach(remover);
    frag.querySelectorAll('.lia-rules-toggle').forEach(function (b) {
        const wrap = b.closest('.text-right');
        remover(wrap && frag.contains(wrap) ? wrap : b);
    });
    frag.querySelectorAll('.lia-rules-panel').forEach(remover);
    frag.querySelectorAll('.lia-chart-card').forEach(remover);
    frag.querySelectorAll('[id*="-chart-"]').forEach(function (n) {
        const card = n.closest('.card-custom');
        remover(card && frag.contains(card) ? card : n);
    });
    frag.querySelectorAll('hr.lia-divider').forEach(remover);
};

const limparAtributos = function (frag) {
    frag.querySelectorAll('*').forEach(function (n) {
        Array.prototype.slice.call(n.attributes).forEach(function (a) {
            const nome = a.name.toLowerCase();
            // name: <img name="X"> cria window.X (DOM clobbering); nada lê name do HTML da IA.
            if (nome === 'id' || nome === 'name' || nome.indexOf('data-') === 0 || nome.indexOf('on') === 0 ||
                nome === 'aria-controls' || nome === 'aria-labelledby' || nome === 'aria-describedby') {
                n.removeAttribute(a.name);
                return;
            }
            // F-5: esquema javascript: em atributo de URL (com espaço/controle antes, em qualquer caixa)
            if (ATRIBUTOS_URL.indexOf(nome) !== -1 && /^[\s\u0000-\u001f]*javascript:/i.test(String(a.value).replace(/[\t\n\r]/g, ''))) {
                n.removeAttribute(a.name);
            }
        });
    });
};

// origem: 'resposta' (result.html novo) ou 'favorito' (fav.html, v1 ou v2).
// Devolve { corpo: DocumentFragment, regras: Array|null, pergunta: string, vazio: bool }.
// regras === null numa resposta nova: quem chama usa result.rules (F-3).
const prepararCorpo = function (html, origem, tituloFav) {
    const t = document.createElement('template');      // 1. parse inerte (não executa <script>)
    t.innerHTML = String(html || '');
    const frag = t.content;
    const fav = origem === 'favorito';

    let pergunta = '';
    if (fav) {                                           // 2b. pergunta: h5 primeiro, fav.title depois
        const h = frag.querySelector('.lia-result-title');
        pergunta = h ? h.textContent.replace(/\s+/g, ' ').trim() : '';
        if (!pergunta) pergunta = String(tituloFav || '').trim();
    }

    const primeiro = frag.firstElementChild;           // 2. geração
    const v2 = !!(primeiro && primeiro.getAttribute('data-lia-saved') === '2');
    let regras = null;
    let corpo;
    if (v2) {
        try { regras = JSON.parse(primeiro.getAttribute('data-lia-rules') || '[]'); } catch (e) { regras = []; }
        if (!Array.isArray(regras)) regras = [];
        corpo = document.createDocumentFragment();
        while (primeiro.firstChild) corpo.appendChild(primeiro.firstChild);
    } else {
        corpo = frag;
        if (fav) {
            regras = regrasDoV1(corpo);                // 3. só v1 + favorito
            limparV1(corpo);                           // 4. só v1
        }
    }

    corpo.querySelectorAll(REMOVER_TODOS).forEach(remover);   // 5.
    removerSmil(corpo);                                        // 5b. R-1 (rev-04)
    limparAtributos(corpo);                                    // 6.

    const vazio = !corpo.querySelector('*') && corpo.textContent.trim() === '';
    return { corpo: corpo, regras: regras, pergunta: pergunta, vazio: vazio };
};

// 7. Cada tabela de nível mais alto ganha um embrulho com rolagem horizontal.
const embrulharTabelas = function (raiz, cls) {
    raiz.querySelectorAll('table').forEach(function (tb) {
        const pai = tb.parentElement;
        if (!pai || (pai.closest('table') && raiz.contains(pai.closest('table')))) return;
        if (pai.classList.contains(cls)) return;
        const w = el('div', cls);
        pai.insertBefore(w, tb);
        w.appendChild(tb);
    });
};

// ── Regras / truncamento ──────────────────────────────────────────────────────────────────────────
const limiteDasRegras = function (regras) {
    const r = (regras || []).find(function (x) { return x && x.regra === 'Limite de registros'; });
    return r ? String(r.valor) : '';
};

// Painel "Mais informações" com as classes do núcleo (.lia-fs-*). Serve à resposta do modal e ao bloco
// Salvo nas duas superfícies. Devolve { botao, painel, faixa } (cada um pode ser null).
const montarRegras = function (regras, idPainel, t) {
    const out = { botao: null, painel: null, faixa: null };
    const lista = Array.isArray(regras) ? regras.filter(function (r) { return r && typeof r === 'object'; }) : [];

    const limite = limiteDasRegras(lista);
    if (limite) {
        const f = el('div', 'lia-fs-trunc');
        f.appendChild(icone('table'));
        f.appendChild(el('span', '', t('truncated', { valor: limite })));
        out.faixa = f;
    }
    if (!lista.length) return out;

    const p = el('div', 'lia-fs-rules');
    p.id = idPainel;
    p.hidden = true;
    p.appendChild(el('div', 'lia-fs-rules-t', t('rulesTitle')));
    const tb = el('table', 'lia-fs-rules-tb');
    const tbody = el('tbody');
    lista.forEach(function (r) {
        const tr = el('tr');
        tr.appendChild(el('td', 'lia-fs-rules-k', String(r.regra === undefined ? '' : r.regra)));
        const td = el('td', 'lia-fs-rules-v');
        if (r.code) td.appendChild(el('code', 'lia-fs-code', String(r.valor === undefined ? '' : r.valor)));
        else td.textContent = String(r.valor === undefined ? '' : r.valor);
        tr.appendChild(td);
        tbody.appendChild(tr);
    });
    tb.appendChild(tbody);
    p.appendChild(tb);
    out.painel = p;

    const b = botao('lia-fs-ob lia-fs-more');
    b.setAttribute('aria-expanded', 'false');
    b.setAttribute('aria-controls', idPainel);
    b.setAttribute('aria-label', t('moreInfo'));
    b.appendChild(icone('funnel'));
    const tx = el('span', 'lia-fs-ob-tx', t('moreInfo'));
    b.appendChild(tx);
    b.addEventListener('click', function () {
        const abrir = p.hidden;
        p.hidden = !abrir;
        b.setAttribute('aria-expanded', abrir ? 'true' : 'false');
        tx.textContent = abrir ? t('lessInfo') : t('moreInfo');
        b.setAttribute('aria-label', tx.textContent);
    });
    out.botao = b;
    return out;
};

// ── Gráficos ──────────────────────────────────────────────────────────────────────────────────────
const temDados = function (cfg) {
    if (!cfg || typeof cfg !== 'object') return false;
    const series = cfg.series || [];
    const labels = cfg.labels || [];
    if (cfg.type === 'pie') {
        const data = (series[0] && series[0].data) || [];
        return data.length > 0 && labels.length > 0;
    }
    return labels.length > 0 && series.length > 0 && series.some(function (s) { return s && s.data && s.data.length > 0; });
};

const alturaGrafico = function () {
    return (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) ? 240 : 300;
};

// Mesmas opções do renderChart original (lia.js). O Apex recebe o ELEMENTO: o gráfico não precisa de id.
const desenharGrafico = function (alvo, cfg, altura) {
    if (!alvo || typeof window.ApexCharts === 'undefined') return false;
    const type = cfg.type || 'bar';
    const labels = cfg.labels || [];
    const series = cfg.series || [];
    const money = cfg.money || false;
    const apexType = (type === 'pie') ? 'pie' : (type === 'area' ? 'area' : (type === 'line' ? 'line' : 'bar'));
    const options = {
        chart: { type: apexType, height: altura || alturaGrafico(), toolbar: { show: false }, fontFamily: 'inherit' },
        colors: ['#3699FF', '#F64E60', '#1BC5BD', '#FFA800', '#8950FC', '#0BB783'],
        legend: { position: 'bottom' },
        tooltip: {
            y: {
                formatter: function (val) {
                    if (money) return 'R$ ' + parseFloat(val).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
                    return parseFloat(val).toLocaleString('pt-BR');
                }
            }
        }
    };
    if (apexType === 'pie') {
        options.series = series.length ? series[0].data : [];
        options.labels = labels;
        options.dataLabels = { enabled: true };
    } else {
        options.series = series;
        options.xaxis = { categories: labels };
        options.dataLabels = { enabled: false };
        if (apexType === 'bar') options.plotOptions = { bar: { borderRadius: 3, columnWidth: '60%' } };
    }
    try {
        new window.ApexCharts(alvo, options).render();
        return true;
    } catch (e) {
        console.warn('[LIA] erro ao desenhar gráfico:', e);
        return false;
    }
};

const listaGraficos = function (charts) {
    if (typeof charts === 'string') {
        try { charts = JSON.parse(charts); } catch (e) { charts = []; }
    }
    return Array.isArray(charts) ? charts : [];
};

// Molduras .lia-fs-chart (modal e bloco Salvo). Chame DEPOIS de o contêiner estar no documento:
// o Apex mede a largura na hora. Devolve quantos gráficos desenhou.
const desenharGraficosNucleo = function (conteiner, charts) {
    let n = 0;
    listaGraficos(charts).forEach(function (cfg) {
        if (!temDados(cfg)) return;
        const moldura = el('div', 'lia-fs-chart');
        if (cfg.title) moldura.appendChild(el('div', 'lia-fs-chart-t', String(cfg.title)));   // F-4: texto
        const area = el('div', 'lia-fs-chart-c');
        moldura.appendChild(area);
        conteiner.appendChild(moldura);
        if (desenharGrafico(area, cfg)) n++;
        else remover(moldura);
    });
    return n;
};

// ── Bloco Salvo (ui-v03, .lia-fs-sv) ──────────────────────────────────────────────────────────────
// opts: { idPainel, t, emModal }. Devolve { bloco, pintar } — insira o bloco e chame pintar() para os gráficos.
const montarBlocoSalvo = function (fav, opts) {
    const t = opts.t;
    const prep = prepararCorpo(fav.html, 'favorito', fav.title);
    const regras = prep.regras || [];
    const charts = listaGraficos(fav.charts);
    const temGrafico = charts.some(temDados);

    const bloco = el('div', 'lia-fs-sv');
    bloco.setAttribute('data-fav-source', String(fav.id));

    const hd = el('div', 'lia-fs-sv-hd');
    const meta = el('div', 'lia-fs-sv-meta');
    const av = el('span', 'lia-fs-sv-av');
    av.setAttribute('aria-hidden', 'true');
    av.appendChild(icone('sparkles-solid'));
    meta.appendChild(av);
    const data = dataSalvo(fav.created);
    meta.appendChild(el('span', 'lia-fs-sv-tag', data ? t('savedOn', { data: data }) : t('savedDone')));
    const rb = montarRegras(regras, opts.idPainel, t);
    if (rb.botao) meta.appendChild(rb.botao);
    hd.appendChild(meta);
    if (prep.pergunta) {
        const q = el('div', 'lia-fs-sv-q', prep.pergunta);
        q.setAttribute('role', 'heading');
        q.setAttribute('aria-level', '3');
        hd.appendChild(q);
    }
    bloco.appendChild(hd);
    if (rb.faixa) bloco.appendChild(rb.faixa);
    if (rb.painel) bloco.appendChild(rb.painel);

    if (prep.vazio && !temGrafico) {
        bloco.appendChild(el('p', 'lia-fs-sv-empty', t('savedEmpty')));
    } else if (!prep.vazio) {
        const res = el('div', 'lia-fs-res');
        res.appendChild(prep.corpo);
        if (opts.emModal) embrulharTabelas(res, 'lia-fs-tw');
        bloco.appendChild(res);
    }

    return {
        bloco: bloco,
        pintar: function () { desenharGraficosNucleo(bloco, charts); }
    };
};

// ── Rolagem ───────────────────────────────────────────────────────────────────────────────────────
const roladorDe = function (n) {
    for (let p = n.parentElement; p; p = p.parentElement) {
        const s = window.getComputedStyle(p);
        if (/(auto|scroll)/.test(s.overflowY) && p.scrollHeight > p.clientHeight) return p;
    }
    return document.scrollingElement || document.documentElement;
};

// Tela cloud-bi/lia: leva o topo do elemento a `folga` px do topo do rolador real da página (no shell 2027
// quem rola é o .content, não a janela).
const rolarPaginaAte = function (n, folga) {
    const r = roladorDe(n);
    const raizDoc = (r === document.scrollingElement || r === document.documentElement);
    const topoR = raizDoc ? 0 : r.getBoundingClientRect().top;
    const alvo = n.getBoundingClientRect().top - topoR + r.scrollTop - (folga || 0);
    $(r).stop(true).animate({ scrollTop: Math.max(0, alvo) }, 400);
};

module.exports = {
    lerTextos: lerTextos,
    tradutor: tradutor,
    escapeHtml: escapeHtml,
    escapeAttr: escapeAttr,
    el: el,
    icone: icone,
    botao: botao,
    dataSalvo: dataSalvo,
    cliente: cliente,
    opcoesCategoria: opcoesCategoria,
    htmlSalvoV2: htmlSalvoV2,
    prepararCorpo: prepararCorpo,
    embrulharTabelas: embrulharTabelas,
    limiteDasRegras: limiteDasRegras,
    montarRegras: montarRegras,
    temDados: temDados,
    alturaGrafico: alturaGrafico,
    desenharGrafico: desenharGrafico,
    listaGraficos: listaGraficos,
    desenharGraficosNucleo: desenharGraficosNucleo,
    montarBlocoSalvo: montarBlocoSalvo,
    rolarPaginaAte: rolarPaginaAte
};
